import { SystemAdmins } from './SystemAdmins'
import { GoogleServiceConnections } from './GoogleServiceConnections'
import { GoogleSetupPage } from './GoogleSetupPage'
import { GoogleFolderAccess } from './GoogleFolderAccess'
import { GoogleDriveSetup } from './GoogleDriveSetup'
import { SystemActivity } from './SystemActivity'
import { SystemOverview } from './SystemOverview'
import { SystemSessions } from './SystemSessions'
import { SystemApps, SystemCompanySetup, SystemCompanies, SystemCompany, SystemPeople } from './SystemDirectory'
import { AccountLinksPage, AppsPage, SecurityPage } from './AccountPages'
import { AccountShell, SessionEntry } from './AccountShell'
import { CompanyLoginPage, ConsentPage, EnrollmentPage, LoginPage, RecoveryPage } from './AuthPages'
import { CompanyPage } from './CompanyPage'
import { NotFound, StatusPage } from './StatusPages'
import { Navigate, useLocation } from './navigation'

function App() {
  const { pathname } = useLocation()
  if (pathname === '/login') return <LoginPage />
  const companyLogin = pathname.match(/^\/c\/([^/]+)\/login$/)
  if (companyLogin) return <CompanyLoginPage slug={decodeURIComponent(companyLogin[1])} />
  const companyEnrollment = pathname.match(/^\/c\/([^/]+)\/enroll$/)
  if (companyEnrollment) return <EnrollmentPage slug={decodeURIComponent(companyEnrollment[1])} />
  const companyRecovery = pathname.match(/^\/c\/([^/]+)\/recover$/)
  if (companyRecovery) return <RecoveryPage slug={decodeURIComponent(companyRecovery[1])} />
  if (pathname === '/recover') return <RecoveryPage />
  if (pathname === '/consent') return <ConsentPage />
  if (pathname === '/account/apps') return <AccountShell><AppsPage /></AccountShell>
  if (pathname === '/account/security') return <AccountShell><SecurityPage /></AccountShell>
  if (pathname === '/account/connectors') return <AccountShell><AccountLinksPage /></AccountShell>
  if (pathname === '/company') return <AccountShell><CompanyPage /></AccountShell>
  if (pathname === '/system') return <Navigate to={`${/service_connected|service_error/.test(window.location.search) ? '/system/connections' : '/system/overview'}${window.location.search}`} replace />
  if (pathname === '/system/overview') return <AccountShell><SystemOverview /></AccountShell>
  if (pathname === '/system/companies') return <AccountShell><SystemCompanies /></AccountShell>
  const systemCompany = pathname.match(/^\/system\/companies\/([^/]+)$/)
  if (systemCompany) return <AccountShell><SystemCompany id={decodeURIComponent(systemCompany[1])} /></AccountShell>
  if (pathname === '/system/people') return <AccountShell><SystemPeople /></AccountShell>
  if (pathname === '/system/apps') return <AccountShell><SystemApps /></AccountShell>
  if (pathname === '/system/company-setup') return <AccountShell><SystemCompanySetup /></AccountShell>
  if (pathname === '/system/activity') return <AccountShell><SystemActivity /></AccountShell>
  if (pathname === '/system/sessions') return <AccountShell><SystemSessions /></AccountShell>
  if (pathname === '/system/folder-access') return <AccountShell><GoogleFolderAccess /></AccountShell>
  if (pathname === '/system/google-setup') return <AccountShell><GoogleSetupPage /></AccountShell>
  if (pathname === '/system/admins') return <AccountShell><SystemAdmins /></AccountShell>
  if (pathname === '/system/connections') return <AccountShell><GoogleServiceConnections /></AccountShell>
  if (pathname === '/system/google-drive') return <AccountShell><GoogleDriveSetup /></AccountShell>
  if (pathname === '/operator') return <Navigate to="/company" replace />
  if (pathname === '/status') return <StatusPage />
  if (pathname === '/') return <SessionEntry />
  return <NotFound />
}

export { loginStartMessage, MemberActionError, signInMessage } from './AuthPages'

export default App
